import React from 'react';
import { Modal } from 'react-bootstrap';
import {Typography, LinearProgress} from '@mui/material'; 


interface PaymentConfirmationModalProps {
  show: boolean;
  handleClose: () => void;
  paymentApproved: boolean;
  progressValue: number;
  descontoTotal: boolean;
  valorInicialTotal: number;
  qrCode: string | null;
}

const PaymentConfirmationModal: React.FC<PaymentConfirmationModalProps> = ({
  show,
  handleClose,
  paymentApproved,
  progressValue,
  descontoTotal,
  valorInicialTotal,
  qrCode,
}) => {
   
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Confirmação de Pagamento</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          margin: 'auto',
        }}
      >
        {paymentApproved ? (
          <div style={{ textAlign: 'center' }}>
            <Typography sx={{ textAlign: 'center', paddingBottom: '10px' }}>
              {progressValue < 100
                ? 'Aguarde, gerando documento.'
                : `Redirecionando em ${Math.ceil(
                    (5000 - (progressValue - 100) * 100) / 1000
                  )}...`}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={progressValue}
              sx={{
                height: '5px',
                borderRadius: '3px',
                marginBottom: '40px',
              }}
            />
            <p>
              Obrigado pela confiança na{' '}
              <b>Atento Medicina de Trabalho LTDA.</b>
            </p>
          </div>
        ) : (
          <>
            <div style={{ textAlign: 'center' }}>
              <p>
                Para finalizar o processo de reaproveitamento, é necessário
                efetuar o pagamento do valor correspondente a esse serviço.
                Por favor, realize o pagamento para concluir o reaproveitamento
                e garantir que todos os procedimentos sejam devidamente
                finalizados. Agradecemos pela sua compreensão e cooperação.
              </p>
              <p style={{ fontSize: '15px' }}>
                <b>Atento Medicina do Trabalho LTDA</b>
                <br />
                Valor: <b>R$ {descontoTotal ? '0,00' : valorInicialTotal}</b>
              </p>
            </div>
            {qrCode ? (
              <img
                src={`data:image/png;base64,${qrCode}`}
                className="qrCode"
                alt="QR Code"
              />
            ) : (
              <p>Carregando QR Code...</p>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PaymentConfirmationModal;
